/**
 *  (stack-like) Object for holding indices of paths selected
 */
export class SelectionPath {
  constructor() {
    this.indices = [];
  }

  add(index) {
    this.indices.push(index);
    return { type: "add", index };
  }

  removeLast() {
    const index = this.indices.pop();
    return { type: "remove", index };
  }

  end() {
    const indices = this.indices;
    this.indices = [];
    return { type: "completed", indices };
  }

  /**
   *  Between (zero-indexed) indices a, b: return true if Chebychev (king's move)
   *  distance is 1 or if is the first index, return false otherwise
   */
  isValidConnection(b) {
    const a = this.last;
    if (a == undefined) return true;

    const ax = a % 4;
    const ay = Math.floor(a / 4);
    const bx = b % 4;
    const by = Math.floor(b / 4);

    return Math.max(Math.abs(ay - by), Math.abs(ax - bx)) == 1;
  }

  canUndo(index) {
    return (
      this.indices.length > 1 &&
      this.indices.at(-2) === index
    );
  }

  has(index) {
    return this.indices.includes(index);
  }

  get last() {
    return this.indices.at(-1);
  }

	toString() {
    return this.indices.toString();
	}
}
